__turbopack_context__.v({
  "accoCardContainer": "Me844G_accoCardContainer",
  "accoDetails": "Me844G_accoDetails",
  "accoName": "Me844G_accoName",
  "accoWrapper": "Me844G_accoWrapper",
  "breadcrumbsSkeleton": "Me844G_breadcrumbsSkeleton",
  "cardFooter": "Me844G_cardFooter",
  "cardFooterSkeleton": "Me844G_cardFooterSkeleton",
  "cardHeader": "Me844G_cardHeader",
  "cardMain": "Me844G_cardMain",
  "imageContainer": "Me844G_imageContainer",
  "nameSkeleton": "Me844G_nameSkeleton",
  "ratingSkeleton": "Me844G_ratingSkeleton",
  "ratingWrapper": "Me844G_ratingWrapper",
  "styledButton": "Me844G_styledButton",
});
